<button
  class="btn btn-close-modal"
  type="button"
  [attr.aria-label]="'textToSpeech.close' | transloco"
  (click)="closeModal()"
>
  <img
    src="assets/images/misc/close.svg"
    alt="{{ 'common.close' | transloco }}"
  />
</button>
@if (thumbs$ | async; as thumbs) {
  @if (!thumbs.length) {
    @if (mainImage$ | async; as main) {
      <div>
        <div class="text-center">
          <img
            class="image"
            [attr.src]="main.zoom?.url"
            [attr.alt]="main.zoom?.altText"
          />
        </div>
      </div>
    }
  }
  @if (thumbs.length) {
    <boels-carousel
      class="thumbs"
      [items]="thumbs"
      itemWidth="100%"
      [hideIndicators]="false"
      [template]="thumb"
      [indicatorIcon]="faCircle"
      [openOnGalleryIndex]="openOnGalleryIndex"
    ></boels-carousel>
  }
}

<ng-template #thumb let-item="item">
  <div>
    <div class="text-center">
      <img
        class="image"
        [attr.src]="item.container.zoom?.url"
        [attr.alt]="item.container.zoom?.altText"
      />
    </div>
  </div>
</ng-template>
